import React from 'react';
import { parseLocalTimestamp } from '../utils/dateUtils';

interface LinkedEvent {
  id: string;
  title: string;
  start_time: string;
  end_time: string;
  is_from_google?: boolean;
}

interface TodoFormLinkedEventsProps {
  events: LinkedEvent[];
}

const TodoFormLinkedEvents: React.FC<TodoFormLinkedEventsProps> = ({
  events,
}) => {
  if (events.length === 0) return null;

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2">
        Scheduled Events
      </label>
      <div className="space-y-2">
        {events.map(event => (
          <div key={event.id} className="flex items-center justify-between p-2.5 bg-indigo-50 border border-indigo-200 rounded-lg text-sm">
            <div className="flex items-center space-x-2">
              <span className="text-indigo-600">📅</span>
              <span className="font-medium text-indigo-800">{event.title}</span>
              <span className="text-indigo-600">
                {parseLocalTimestamp(event.start_time).toLocaleDateString()}{' '}
                {parseLocalTimestamp(event.start_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                {' - '}
                {parseLocalTimestamp(event.end_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
            {event.is_from_google && (
              <span className="text-xs text-gray-500">Google Calendar</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TodoFormLinkedEvents;
